/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as RelationshipsRouteImport } from './routes/relationships'
import { Route as ProfileRouteImport } from './routes/profile'
import { Route as LoginRouteImport } from './routes/login'
import { Route as FeedRouteImport } from './routes/feed'
import { Route as DashboardRouteImport } from './routes/dashboard'
import { Route as CalendarRouteImport } from './routes/calendar'
import { Route as IndexRouteImport } from './routes/index'
import { Route as TasksIndexRouteImport } from './routes/tasks/index'
import { Route as TasksCreateRouteImport } from './routes/tasks/create'
import { Route as TasksTaskIdRouteImport } from './routes/tasks/$taskId'

const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/settings.lazy').then((d) => d.Route))
const RelationshipsRoute = RelationshipsRouteImport.update({
  id: '/relationships',
  path: '/relationships',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/relationships.lazy').then((d) => d.Route))
const ProfileRoute = ProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/profile.lazy').then((d) => d.Route))
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/login.lazy').then((d) => d.Route))
const FeedRoute = FeedRouteImport.update({
  id: '/feed',
  path: '/feed',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/feed.lazy').then((d) => d.Route))
const DashboardRoute = DashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/dashboard.lazy').then((d) => d.Route))
const CalendarRoute = CalendarRouteImport.update({
  id: '/calendar',
  path: '/calendar',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/calendar.lazy').then((d) => d.Route))
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const TasksIndexRoute = TasksIndexRouteImport.update({
  id: '/tasks/',
  path: '/tasks/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/tasks/index.lazy').then((d) => d.Route))
const TasksCreateRoute = TasksCreateRouteImport.update({
  id: '/tasks/create',
  path: '/tasks/create',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/tasks/create.lazy').then((d) => d.Route))
const TasksTaskIdRoute = TasksTaskIdRouteImport.update({
  id: '/tasks/$taskId',
  path: '/tasks/$taskId',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/tasks/$taskId.lazy').then((d) => d.Route))

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/calendar': typeof CalendarRoute
  '/dashboard': typeof DashboardRoute
  '/feed': typeof FeedRoute
  '/login': typeof LoginRoute
  '/profile': typeof ProfileRoute
  '/relationships': typeof RelationshipsRoute
  '/settings': typeof SettingsRoute
  '/tasks/$taskId': typeof TasksTaskIdRoute
  '/tasks/create': typeof TasksCreateRoute
  '/tasks/': typeof TasksIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/calendar': typeof CalendarRoute
  '/dashboard': typeof DashboardRoute
  '/feed': typeof FeedRoute
  '/login': typeof LoginRoute
  '/profile': typeof ProfileRoute
  '/relationships': typeof RelationshipsRoute
  '/settings': typeof SettingsRoute
  '/tasks/$taskId': typeof TasksTaskIdRoute
  '/tasks/create': typeof TasksCreateRoute
  '/tasks': typeof TasksIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/calendar': typeof CalendarRoute
  '/dashboard': typeof DashboardRoute
  '/feed': typeof FeedRoute
  '/login': typeof LoginRoute
  '/profile': typeof ProfileRoute
  '/relationships': typeof RelationshipsRoute
  '/settings': typeof SettingsRoute
  '/tasks/$taskId': typeof TasksTaskIdRoute
  '/tasks/create': typeof TasksCreateRoute
  '/tasks/': typeof TasksIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/calendar'
    | '/dashboard'
    | '/feed'
    | '/login'
    | '/profile'
    | '/relationships'
    | '/settings'
    | '/tasks/$taskId'
    | '/tasks/create'
    | '/tasks/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/calendar'
    | '/dashboard'
    | '/feed'
    | '/login'
    | '/profile'
    | '/relationships'
    | '/settings'
    | '/tasks/$taskId'
    | '/tasks/create'
    | '/tasks'
  id:
    | '__root__'
    | '/'
    | '/calendar'
    | '/dashboard'
    | '/feed'
    | '/login'
    | '/profile'
    | '/relationships'
    | '/settings'
    | '/tasks/$taskId'
    | '/tasks/create'
    | '/tasks/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  CalendarRoute: typeof CalendarRoute
  DashboardRoute: typeof DashboardRoute
  FeedRoute: typeof FeedRoute
  LoginRoute: typeof LoginRoute
  ProfileRoute: typeof ProfileRoute
  RelationshipsRoute: typeof RelationshipsRoute
  SettingsRoute: typeof SettingsRoute
  TasksTaskIdRoute: typeof TasksTaskIdRoute
  TasksCreateRoute: typeof TasksCreateRoute
  TasksIndexRoute: typeof TasksIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/relationships': {
      id: '/relationships'
      path: '/relationships'
      fullPath: '/relationships'
      preLoaderRoute: typeof RelationshipsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/profile': {
      id: '/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof ProfileRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/feed': {
      id: '/feed'
      path: '/feed'
      fullPath: '/feed'
      preLoaderRoute: typeof FeedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard': {
      id: '/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof DashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/calendar': {
      id: '/calendar'
      path: '/calendar'
      fullPath: '/calendar'
      preLoaderRoute: typeof CalendarRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tasks/': {
      id: '/tasks/'
      path: '/tasks'
      fullPath: '/tasks/'
      preLoaderRoute: typeof TasksIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tasks/create': {
      id: '/tasks/create'
      path: '/tasks/create'
      fullPath: '/tasks/create'
      preLoaderRoute: typeof TasksCreateRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tasks/$taskId': {
      id: '/tasks/$taskId'
      path: '/tasks/$taskId'
      fullPath: '/tasks/$taskId'
      preLoaderRoute: typeof TasksTaskIdRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  CalendarRoute: CalendarRoute,
  DashboardRoute: DashboardRoute,
  FeedRoute: FeedRoute,
  LoginRoute: LoginRoute,
  ProfileRoute: ProfileRoute,
  RelationshipsRoute: RelationshipsRoute,
  SettingsRoute: SettingsRoute,
  TasksTaskIdRoute: TasksTaskIdRoute,
  TasksCreateRoute: TasksCreateRoute,
  TasksIndexRoute: TasksIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
